import { Extension } from '@tiptap/core';

import {
  extractGoogleDocId,
  extractGoogleSlidesId,
  isGoogleDocUrl,
  isGoogleSlidesUrl,
} from '@spotify/confidence-core-react';

import { createProviderPastePlugin } from './createProviderPastePlugin';

export type GoogleDrivePasteResult = {
  url: string;
  fileId: string;
  sourceType: 'GOOGLE_DOCS' | 'GOOGLE_SLIDES';
};

export const extractGoogleDriveFromPaste = (
  text: string,
): GoogleDrivePasteResult | undefined => {
  const trimmed = text.trim();
  if (!trimmed || /\s/.test(trimmed)) {
    return undefined;
  }
  if (isGoogleDocUrl(trimmed)) {
    const fileId = extractGoogleDocId(trimmed);
    if (!fileId) return undefined;
    return { url: trimmed, fileId, sourceType: 'GOOGLE_DOCS' };
  }
  if (isGoogleSlidesUrl(trimmed)) {
    const fileId = extractGoogleSlidesId(trimmed);
    if (!fileId) return undefined;
    return { url: trimmed, fileId, sourceType: 'GOOGLE_SLIDES' };
  }
  return undefined;
};

export type OnGoogleDrivePasted = (result: GoogleDrivePasteResult) => void;

export const createGoogleDrivePastePlugin = (
  onPastedRef: React.RefObject<OnGoogleDrivePasted | null>,
): Extension =>
  createProviderPastePlugin(
    'googleDocPaste',
    extractGoogleDriveFromPaste,
    onPastedRef,
  );
